"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function restrictToServer(Component) {
  if (typeof window !== 'undefined') {
    var NoopComponent = function NoopComponent() {
      return null;
    };

    NoopComponent.displayName = Component.displayName || Component.name;
    return NoopComponent;
  }

  return Component;
}

exports.restrictToServer = restrictToServer;